export default __webpack_public_path__ + "static/media/notion-wordmark 1.5e00b8f7.svg";